import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/index"
    },
    {
      path: "/index",
      component: () => import("@/views/index/index"),
      meta: { title: "HOLA" }
    },
    {
      path: "*",
      component: () => import("@/components/NotFound"),
      meta: { title: "Page Not Found - HOLA" }
    }
  ]
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "HOLA";
  next();
});

export default router;
